// extracted by mini-css-extract-plugin
export default {"container":"container--lGr-O","title":"title--zPwhf","description":"description--sDPCd","separator":"separator--ciE+x","bottom":"bottom--eUzSo"};